import { Column } from './column';
import { Row } from './row';

export interface Table<T = Row> {
  columns: Column[];
  rows: T[];
}

export function TABLE_EMPTY(): Table<any> {
  return { columns: [], rows: [] };
}
